import { MISC, NP_NP, TO_BE_INITIATED, NOT_SETTLED, SETTLED } from "../constants/constants"
export const orderData =
[
    {
        "Id": 1,
        "OrderId": "2024-12-23-138156",
        "CollectorAppId": "buyer-app-preprod-v2.ondc.org",
        "ReceiverAppId": "preprod-bpp.dbs.digiit.io",
        "SettlementRequestTypeId": NP_NP,        
        "SettlementRequestStatusId": TO_BE_INITIATED,
        "CreatedOnUtc": "2024-12-30T05:45:06.027Z",
        "UpdatedOnUtc": "2024-12-30T05:45:06.027Z"
    },
    {
        "Id": 2,
        "OrderId": "2024-12-23-944186",
        "CollectorAppId": "buyer-app-preprod-v2.ondc.org",
        "ReceiverAppId": "preprod-bpp.dbs.digiit.io",
        "SettlementRequestTypeId": NP_NP,        
        "SettlementRequestStatusId": TO_BE_INITIATED,
        "CreatedOnUtc": "2024-12-30T06:21:14.954Z",
        "UpdatedOnUtc": "2024-12-30T06:21:14.954Z"

    },
    {
        "Id": 3,
        "OrderId": "2024-12-23-858882",
        "CollectorAppId": "buyer-app-preprod-v2.ondc.org",
        "ReceiverAppId": "preprod-bpp.dbs.digiit.io",
        "SettlementRequestTypeId": MISC,        
        "SettlementRequestStatusId": TO_BE_INITIATED,
        "CreatedOnUtc": "2024-12-30T06:12:26.049Z",
        "UpdatedOnUtc": "2024-12-30T06:12:26.049Z"
    },
    {
        "Id": 4,
        "OrderId": "dP37R1jin8ffNi1ey8juscYLtiB4nG38",
        "CollectorAppId": "pramaan.ondc.org/alpha/mock-server",
        "ReceiverAppId": "preprod-bpp.dbs.digiit.io",
        "SettlementRequestTypeId": NP_NP,        
        "SettlementRequestStatusId": TO_BE_INITIATED,
        "CreatedOnUtc": "2024-12-25T13:56:52.898Z",
        "UpdatedOnUtc": "2024-12-25T13:56:52.898Z"
    },
    {
        "Id": 5,
        "OrderId": "a6pQWH33iHfTh0H5yE2lx0aCACgkjZlM",
        "CollectorAppId": "pramaan.ondc.org/alpha/mock-server",
        "ReceiverAppId": "preprod-bpp.dbs.digiit.io",
        "SettlementRequestTypeId": NP_NP,        
        "SettlementRequestStatusId": TO_BE_INITIATED,
        "CreatedOnUtc": "2024-12-25T14:03:53.059Z",
        "UpdatedOnUtc": "2024-12-25T14:03:53.059Z"
    }
    
]